import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { ParticipantInbox } from '@/features/participant-portal'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-inbox/',
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact']),
  component: ParticipantInbox,
})
